import { useTranslation } from '../i18n'
import SEO from '../components/SEO'
import Features from '../components/sections/Features'
import DownloadCTA from '../components/sections/DownloadCTA'
import './FeaturesPage.css'

function FeaturesPage() {
  const { t } = useTranslation()

  const detailedFeatures = [
    {
      categoryKey: 'categoryAudioSpeech',
      features: [
        {
          titleKey: 'featureRealTimeSpeech',
          descKey: 'featureRealTimeSpeechDesc',
          detailKeys: [
            'featureRealTimeSpeechDetail1',
            'featureRealTimeSpeechDetail2',
            'featureRealTimeSpeechDetail3',
            'featureRealTimeSpeechDetail4',
          ],
        },
        {
          titleKey: 'featureSpeakerDiff',
          descKey: 'featureSpeakerDiffDesc',
          detailKeys: [
            'featureSpeakerDiffDetail1',
            'featureSpeakerDiffDetail2',
            'featureSpeakerDiffDetail3',
          ],
        },
      ],
    },
    {
      categoryKey: 'categoryVisualIntelligence',
      features: [
        {
          titleKey: 'featureScreenRecognition',
          descKey: 'featureScreenRecognitionDesc',
          detailKeys: [
            'featureScreenRecognitionDetail1',
            'featureScreenRecognitionDetail2',
            'featureScreenRecognitionDetail3',
            'featureScreenRecognitionDetail4',
          ],
        },
        {
          titleKey: 'featureContextBuilding',
          descKey: 'featureContextBuildingDesc',
          detailKeys: [
            'featureContextBuildingDetail1',
            'featureContextBuildingDetail2',
            'featureContextBuildingDetail3',
          ],
        },
      ],
    },
    {
      categoryKey: 'categoryAiHints',
      features: [
        {
          titleKey: 'featureAnswerHints',
          descKey: 'featureAnswerHintsDesc',
          detailKeys: [
            'featureAnswerHintsDetail1',
            'featureAnswerHintsDetail2',
            'featureAnswerHintsDetail3',
            'featureAnswerHintsDetail4',
          ],
        },
        {
          titleKey: 'featureDepthHints',
          descKey: 'featureDepthHintsDesc',
          detailKeys: [
            'featureDepthHintsDetail1',
            'featureDepthHintsDetail2',
            'featureDepthHintsDetail3',
            'featureDepthHintsDetail4',
          ],
        },
        {
          titleKey: 'featureLateralHints',
          descKey: 'featureLateralHintsDesc',
          detailKeys: [
            'featureLateralHintsDetail1',
            'featureLateralHintsDetail2',
            'featureLateralHintsDetail3',
            'featureLateralHintsDetail4',
          ],
        },
        {
          titleKey: 'featureQuestionClass',
          descKey: 'featureQuestionClassDesc',
          detailKeys: [
            'featureQuestionClassDetail1',
            'featureQuestionClassDetail2',
            'featureQuestionClassDetail3',
            'featureQuestionClassDetail4',
          ],
        },
      ],
    },
  ] as const

  return (
    <>
      <SEO
        title="Features"
        description="Explore Intervio's powerful features: real-time speech transcription, AI question detection, answer, depth & lateral hints, screen OCR, cloud and local processing modes."
        path="/features"
      />
      <section className="features-hero">
        <div className="container">
          <h1>{t('featuresPageTitle')}</h1>
          <p>{t('featuresPageSubtitle')}</p>
        </div>
      </section>

      <Features />

      <section className="section detailed-features">
        <div className="container">
          {detailedFeatures.map((category, idx) => (
            <div key={idx} className="feature-category">
              <h2 className="category-title">{t(category.categoryKey)}</h2>
              <div className="category-features">
                {category.features.map((feature, fidx) => (
                  <div key={fidx} className="detailed-feature-card">
                    <h3>{t(feature.titleKey)}</h3>
                    <p>{t(feature.descKey)}</p>
                    <ul className="feature-details">
                      {feature.detailKeys.map((detailKey, didx) => (
                        <li key={didx}>
                          <span className="check-icon">✓</span>
                          {t(detailKey)}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <DownloadCTA />
    </>
  )
}

export default FeaturesPage
